import React, { createContext, useState, useEffect, useCallback, useContext } from "react";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState(undefined); // undefined = pas encore chargé
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("/api/me", { method: "GET", credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => setState(data))
      .catch(() => setState(null))
      .finally(() => setLoading(false));
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const res = await fetch("/api/me", { method: "GET", credentials: "include" });
      if (!res.ok) throw new Error("Not logged in");
      const data = await res.json();
      setState(data);
    } catch {
      // ne pas déconnecter sur une erreur réseau passagère
    }
  }, []);

  const logout = useCallback(() => setState(null), []);

  return (
    <AuthContext.Provider value={{ state, setState, loading, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
